export default __webpack_public_path__ + "static/media/live_end.e95b0d5e.png";